import axios from "axios"
import { Toast } from "vant"
import { API_BASE_URL } from "@/config"
import { getLoginUserId } from "@/utils/auth"

export const request = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20000,
  headers: {
    "Content-Type": "application/json"
  }
})

request.interceptors.request.use(
  config => {
    const userId = getLoginUserId()
    if (userId) {
      config.headers["X-Userid"] = userId
    }
    return config
  },
  err => Promise.reject(err)
)

request.interceptors.response.use(
  res => res,
  err => {
    const message =
      err?.response?.data?.message ||
      err?.response?.data?.msg ||
      err?.message ||
      "网络异常，请稍后重试"
    Toast.fail(message)
    return Promise.reject(err)
  }
)

